<template>
  <div v-if="comType == 'UI'">
    <div
      :style="{
        height: `${comHeight}px`,
        'background-color': backgroundColor,
      }"
    ></div>
  </div>
  <div v-else-if="comType == 'config'">
    <el-form ref="form" label-width="100px" size="small">
      <div>
        <el-form-item label="背景颜色">
          <el-color-picker
            v-model="backgroundColorValue"
            :predefine="predefineColorsAlpha"
            size="small"
            show-alpha
          ></el-color-picker>
        </el-form-item>
      </div>
      <div>
        <el-form-item label="高度">
          <div class="slider-block">
            <el-slider v-model="comHeightValue" show-input :min="1" :max="750">
            </el-slider>
          </div>
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>

<script>
import { comMixins } from "@/mixins/comMixins";

export default {
  mixins: [comMixins],
  name: "comLine",
  props: {
    comType: {
      type: String,
      default: "UI",
    },
    comHeight: {
      type: Number,
      default: 10,
    },
    backgroundColor: {
      type: String,
      default: "rgb(64, 158, 255, 1)",
    },
  },
  computed: {
    comHeightValue: {
      get() {
        return this.comHeight;
      },
      set(val) {
        this.$emit(`update:comHeight`, val);
      },
    },
    backgroundColorValue: {
      get() {
        return this.backgroundColor;
      },
      set(val) {
        this.$emit(`update:backgroundColor`, val);
      },
    },
  },
};
</script>

<style scoped lang="less"></style>
